export default __webpack_public_path__ + "static/media/speciman.abf4a4d2.svg";